// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-progress-display {
  position: relative;
  height: 100vh;
  text-align: center; }
  .center-progress-display i {
    position: absolute;
    bottom: 75%;
    color: white;
    font-size: 40px; }
  .center-progress-display .progress {
    position: absolute;
    bottom: 63%;
    left: 5%;
    right: 5%;
    height: 0.5rem; }
    .center-progress-display .progress .bar {
      background-color: white; }
  .center-progress-display .number-display {
    position: absolute;
    bottom: 58%;
    left: 50%;
    right: 50%;
    color: white; }

.loading-page {
  position: relative;
  float: left; }

.loading-page-logo {
  margin: 100px 0px; }
  .loading-page-logo img {
    display: block;
    margin: auto;
    width: 50%;
    max-width: 550px; }
`, "",{"version":3,"sources":["webpack://./src/components/LoadingPage/LoadingPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB,EAAE;EACpB;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe,EAAE;EACnB;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,cAAc,EAAE;IAChB;MACE,uBAAuB,EAAE;EAC7B;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;IACV,YAAY,EAAE;;AAElB;EACE,kBAAkB;EAClB,WAAW,EAAE;;AAEf;EACE,iBAAiB,EAAE;EACnB;IACE,cAAc;IACd,YAAY;IACZ,UAAU;IACV,gBAAgB,EAAE","sourcesContent":[".center-progress-display {\n  position: relative;\n  height: 100vh;\n  text-align: center; }\n  .center-progress-display i {\n    position: absolute;\n    bottom: 75%;\n    color: white;\n    font-size: 40px; }\n  .center-progress-display .progress {\n    position: absolute;\n    bottom: 63%;\n    left: 5%;\n    right: 5%;\n    height: 0.5rem; }\n    .center-progress-display .progress .bar {\n      background-color: white; }\n  .center-progress-display .number-display {\n    position: absolute;\n    bottom: 58%;\n    left: 50%;\n    right: 50%;\n    color: white; }\n\n.loading-page {\n  position: relative;\n  float: left; }\n\n.loading-page-logo {\n  margin: 100px 0px; }\n  .loading-page-logo img {\n    display: block;\n    margin: auto;\n    width: 50%;\n    max-width: 550px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
